import React, {Component} from 'react';
import {Col, FormText, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import NumberFormat from "react-number-format";
import FormGroup from "react-bootstrap/FormGroup";
import {request} from "../../../helper/APIUtils";
import {showAxiosError} from "../../../helper/helper";
import Datetime from "react-datetime";
import moment from "moment/moment";

class CreditChangeModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            manual: false,
            selected: [],
            creditData: {
                baslangicTarihi: moment(this.props.selectedRow.startDate).format("YYYY-MM-DD"),
                sonKullanimTarihi: moment(this.props.selectedRow.expireDate).format("YYYY-MM-DD"),
            },
            error: {},
        };
        this.closeCreditChangeModal = this.closeCreditChangeModal.bind(this);
        this.onValueChange = this.onValueChange.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onChangeDate = this.onChangeDate.bind(this);
        this.checkDateValidity = this.checkDateValidity.bind(this);

    }

    componentDidMount() {
        this.setState({selected: this.props.selectedRow});
    }

    closeCreditChangeModal() {
        this.props.toggle();
    }

    onValueChange(e, id) {
        let creditData = this.state.selected;
        const {value} = e;

        creditData[id] = value;
        this.setState({selected: creditData});
    }

    onSave() {
        let self = this;
        let formData = new FormData();

        formData.append("recordId", this.state.selected.recordId);
        formData.append("consideredCount", this.state.selected.consideredCount);
        formData.append("startDate",  this.state.creditData.baslangicTarihi);
        formData.append("expireDate",  this.state.creditData.sonKullanimTarihi);

            let params = {
                url: "/customer/updateCreditPurchase",
                method: "post",
                data: formData,
            };
            request(params)
                .then(function (response) {
                    self.setState({data: response.data})
                    self.closeCreditChangeModal();
                }).catch(function (error) {
                showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
            });

    }
    onChangeDate(momentObj, type, fieldName) {

        let value;
        let {creditData, error} = this.state;
        if (!(typeof momentObj === "string")) {

            value = momentObj.format("YYYY-MM-DD");
            error[fieldName] = undefined

        } else {
            value = moment(momentObj,"YYYY-MM-DD");
            error[fieldName] = {className: "is-invalid", message: "Tarih formatı hatalı. GG-AA-YYYY biçimine uyunuz."}

        }
        creditData[fieldName] = value;
        this.setState({creditData, error})
    }

    checkDateValidity(current, field) {
        let now = moment().subtract(1, "days");
        if (field === 'baslangicTarihi') {
            return current.isSameOrAfter(now);
        }
        if (field === 'sonKullanimTarihi') {
            let startDate = moment(this.state.creditData.baslangicTarihi);
            return current.isAfter(startDate);
        }
    }

    render() {
        let error = this.state.error;
        return (
            <Modal isOpen={this.props.modal} size='md'>
                <ModalHeader toggle={this.closeCreditChangeModal}>Kontör Miktar Düzenleme</ModalHeader>
                <ModalBody>
                    <div className="col-sm-12 row" style={{right: '-15px'}}>

                            <Col md={12}>
                                <FormGroup>
                                    <label style={{fontWeight: 'bold', display: 'block', textAlign: 'center', margin: '0 20px 20px 0', fontSize: '17px'}}>
                                        Miktar
                                    </label>
                                    <NumberFormat id="consideredCount"
                                                  value={this.state.selected.consideredCount}
                                                  allowNegative={false}
                                                  isNumericString={true}
                                                  allowEmptyFormatting={false}
                                                  decimalScale={0}
                                                  thousandSeparator={'.'}
                                                  decimalSeparator={','}
                                                  displayType="input"
                                                  isAllowed={values => {
                                                      return (values.value !== "");
                                                  }}
                                                  placeholder=""
                                                  renderText={value => {
                                                      value.replace(/\./g, ',')
                                                  }}
                                                  onValueChange={e => this.onValueChange(e, "consideredCount")}
                                                  className="form-control"/>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="baslangicTarihi">Başlangıç Tarihi</Label>
                                    <Datetime locale="tr"
                                              inputProps={{
                                                  id: "baslangicTarihi",
                                                  class: (error.baslangicTarihi ? error.baslangicTarihi.className + " form-control" : "form-control")
                                              }}
                                              className="datepicker"
                                              input={true}
                                              closeOnSelect={true}
                                              value={moment(this.state.creditData.baslangicTarihi, "YYYY-MM-DD", true).isValid() ? moment(this.state.creditData.baslangicTarihi).format("DD-MM-YYYY") : this.state.creditData.baslangicTarihi}
                                              dateFormat="DD-MM-YYYY"
                                              timeFormat={false}
                                              isValidDate={(current) => this.checkDateValidity(current, "baslangicTarihi")}
                                              onChange={(e) => this.onChangeDate(e, "date", "baslangicTarihi")}/>
                                    {error.baslangicTarihi &&
                                    <FormText className="text-danger">
                                        {error.baslangicTarihi.message}
                                    </FormText>
                                    }
                                </FormGroup>
                                <FormGroup>
                                    <Label for="sonKullanimTarihi">Son Kullanım Tarihi</Label>
                                    <Datetime locale="tr"
                                            inputProps={{
                                                id: "sonKullanimTarihi",
                                                class: (error.baslangicTarihi ? error.baslangicTarihi.className + " form-control" : "form-control")
                                            }}
                                            className="datepicker"
                                            input={true}
                                            closeOnSelect={true}
                                            value={moment(this.state.creditData.sonKullanimTarihi, "YYYY-MM-DD", true).isValid() ? moment(this.state.creditData.sonKullanimTarihi).format("DD-MM-YYYY") : this.state.creditData.sonKullanimTarihi}
                                            dateFormat="DD-MM-YYYY"
                                            timeFormat={false}
                                            isValidDate={(current) => this.checkDateValidity(current, "sonKullanimTarihi")}
                                            onChange={(e) => this.onChangeDate(e, "date", "sonKullanimTarihi")}/>
                                    {error.sonKullanimTarihi &&
                                    <FormText className="text-danger">
                                        {error.sonKullanimTarihi.message}
                                    </FormText>
                                    }
                                </FormGroup>
                            </Col>

                    </div>
                </ModalBody>
                <ModalFooter>
                    <button type="button" onClick={this.closeCreditChangeModal}
                            className=" TekBtn vazgec" style={{
                        background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                        padding: '9px 45px 9px 20px'
                    }}>Vazgeç
                    </button>
                    <div className="col-sm-6"></div>
                    <button type="button" onClick={this.onSave} style={{padding: '9px 45px 9px 20px'}}
                            disabled={this.state.loading} className="  TekBtn kaydet pull-right"
                    >Güncelle
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default CreditChangeModal;